import { inject, Injectable } from '@angular/core';
import { DataContextService } from '@seahorse/common';

@Injectable({
  providedIn: 'root',
})
export class BusinessLogicService {
  private _dataContext = inject(DataContextService);

  evaluateConditions(businessLogic: any, data: any) {
    return this._dataContext.post<any>('business-logic/evaluate/conditions', {
      businessLogic,
      data,
    });
  }
}
